const button = document.querySelector("#mts_calculator_button")
const input = document.querySelector("#mts_calculator_number_of_beds");
const thankyouBtn = document.querySelector("#mts_calculator_thank_button");

if(button) {
    button.addEventListener("click", (function() {
        calculateEligibility();
    }))
    input.addEventListener("keypress", (function(e) {
        if(e.key === "Enter") calculateEligibility();
    }))

    thankyouBtn.addEventListener("click", function() {
        let randomId = createUID();
        setPccShortTokenCookie("pcc_form_receipt", randomId);
    })    
}

function calculateEligibility(){
    const cost = 0.98 * 365;
    const nOfBeds = input.value;
    if(nOfBeds) {
        document.querySelector("#mts_calculator_2y").innerHTML = formatValue(parseInt(nOfBeds) * cost);
        document.querySelector("#mts_calculator_3y").innerHTML = formatValue(parseInt(nOfBeds) * cost);
        document.querySelector("#mts_calculator_total").innerHTML = formatValue(parseInt(nOfBeds) * (2 * cost));
    }
}

function formatValue(val){
    if (val) {
        return `$ ${Math.round(val).toLocaleString('en-US')}`;

    } 
    return "0";
}

//Sets a temporary cookie with a unique token for a purchase receipt to redirect the Thank you page when expired.
function setPccShortTokenCookie (cname, cvalue){
    var d = new Date();
    d.setTime(d.getTime() + 20 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/; secure";

    redirectToTyPage();
};

function redirectToTyPage(){
    let url = thankyouBtn.dataset.ctaLink;
    if(url.slice(-1) === '/'){
        url = url.slice(0, -1);
    }

    //Send to thank you page with params
    window.location.href = url + '?inquiry=ontario-mst-calculator';
}

function createUID(){
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*32)%32 | 0;
        dt = Math.floor(dt/32);
        return (c=='x' ? r :(r&0x3|0x8)).toString(32);
    });
    return uuid.toUpperCase();
}